import LoadingBox from 'components/Common/Loading/LoadingBox'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import { fillArray, nonNullable } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ExperienceSearchTile from '../ExperienceTiles/ExperienceSearchTile'
import Typography from 'LuxKit/Typography/Typography'
import { viewItemListExperiences } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import OfferListLoadMoreButton from 'components/OfferList/OfferListLoadMoreButton'

export const SkeletonTile = styled(LoadingBox)`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  min-height: ${rem(284)};
`

const ListGrid = styled.div`
  display: grid;
  gap: ${rem(24)};
`

interface Props {
  placeId: string
  sortBy?: Experiences.SortTypes
  categoryCodes?: Array<number>
  priceLte?: number
  priceGte?: number
  excludeIds?: Array<string>
  luxPlusFeatures?: Array<App.LuxPlusFeatureFilter>
}

function ExperienceSearchList(props: Props) {
  const {
    placeId,
    sortBy,
    categoryCodes,
    priceGte,
    priceLte,
    excludeIds,
    luxPlusFeatures,
  } = props
  const [page, setPage] = useState<number>(1)
  const limit = page * 4
  const [list, experiences] = useExperienceSearch({ placeId, limit, sortBy, excludeIds }, { categoryCodes, priceGte, priceLte, luxPlusFeatures })
  const hasMore = !!list && experiences.length < list.ids.length

  useEffect(() => {
    if (experiences?.length) {
      const event = viewItemListExperiences(nonNullable(experiences))
      if (event) {
        addGTMEvent(event)
      }
    }
  }, [experiences])

  return <div>
    <ListGrid>
      {(!list || list.fetching) && fillArray(4).map((id) => <SkeletonTile key={id} />)}
      {list && !list.fetching && experiences.map((exp, idx) => <React.Fragment key={`${exp?.id}-${idx}`}>
        {!exp && <SkeletonTile />}
        {exp && <ExperienceSearchTile
          experience={exp}
          position={idx}
        />}
      </React.Fragment>)}
    </ListGrid>
    {hasMore && <Typography align="center">
      <OfferListLoadMoreButton
        onScrollNear={() => setPage(page + 1)}
        onClick={() => setPage(page + 1)}
      >
        Load more
      </OfferListLoadMoreButton>
    </Typography>}
  </div>
}

export default ExperienceSearchList
